import { render, staticRenderFns } from "./form-share.vue?vue&type=template&id=5e2d9d48&"
import script from "./form-share.vue?vue&type=script&lang=js&"
export * from "./form-share.vue?vue&type=script&lang=js&"
import style0 from "./form-share.vue?vue&type=style&index=0&id=5e2d9d48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports